import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { getDescryptedMedia, urlSearchParams } from 'srcReact/helpers/utils'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { lightProfileActions } from './actions'
import { checkNested } from 'srcReact/helpers/validator'
import ReactMenu from '../ReactMenu'
import history from 'srcReact/helpers/history'
import config from 'config'
import Modal from '../Modal'
import MobileModal from '../MobileModal'
import LightProfile from './components/LightProfile'
import Loader from '../Loader'
import MessengerMobile from 'srcReact/MessengerPage/MessengerMobile'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export default function LightProfileModal({
  show,
  userIdwithRole = 0,
  userswithRole = null,
  userIndexWithRole = 0,
  messengerMessage = '',
  roleManagementOptions = null,
  closeModalWithRole,
  navigateWithRole,
  screenWithRole = 'main'
}) {
  const { t } = useTranslation()
  const [id, setId] = useState(0)
  const [userIndex, setUserIndex] = useState(0)
  const dispatch = useDispatch()
  const [isFileModalOpen, setIsFileModalOpen] = useState(false)
  const [invalidUser, setInvalidUser] = useState(false)
  const [screenType, setScreenType] = useState('main') //main, group-list, mixr-list, messenger
  const {
    common: { isNative, isMobile },
    login: { user: loggedInUser },
    organization: { current_organization },
    lightProfile: { user, interests, loading, interestGroups, mixrs, userInput, error, userStatus, expertiseGroups }
  } = useSelector((state) => state)
  const [options, setOptions] = useState([])

  const [profilePicture, setProfilePicture] = useState(null)
  const isMessenger = history.location.pathname.match(/messenger/)
  const isProfile = history.location.pathname.match(/profile/)

  const changeScreen = (type) => {
    setScreenType(type)
  }

  useEffect(() => {
    if (userStatus) {
      setInvalidUser(userStatus === 'deactivated' || userStatus === 'deleted')
    }
  }, [userStatus])

  useEffect(() => {
    if (userIdwithRole > 0) {
      setId(userIdwithRole)
      setUserIndex(userIndexWithRole)
    }
  }, [userIdwithRole])

  const getOrganizationId = () => {
    return isNative
      ? urlSearchParams('organization_id')
      : current_organization && current_organization.info && current_organization.info.id
  }

  const showSendMessageModal = () => {
    setScreenType('messenger')
  }

  const hideSendMessageModal = () => {
    setScreenType('main')
  }

  useEffect(() => {
    if (userInput && userInput.screen) {
      setScreenType(userInput.screen)
    } else {
      setScreenType(screenWithRole)
    }
  }, [userInput && userInput.screen])
  useEffect(() => {
    if (id > 0) {
      const payload = {
        information_type: 'light',
        user_id: id,
        organization_id: getOrganizationId()
      }
      dispatch(lightProfileActions.getUserLightProfile(payload))
    }
  }, [id])

  useEffect(() => {
    if (userInput) {
      setId(userInput.userId)
      setUserIndex(userInput.userIndex)
    }
  }, [userInput && userInput.userId])

  useEffect(() => {
    return () => {
      dispatch(lightProfileActions.clearData())
      document.body.style.overflow = 'unset'
    }
  }, [])

  useEffect(() => {
    const items = []
    if (id > 0) {
      if (loggedInUser.id !== id) {
        // if ((userInput && userInput.showSendMessage) || loggedInUser.id !== id) {
        items.push({
          text: t('profile_light.send_message'),
          onClick: () => sendMessage(id)
        })
      }
      if (roleManagementOptions && roleManagementOptions.length > 0) {
        roleManagementOptions.forEach((option) => {
          items.push({
            text: option.text,
            onClick: option.onClick
          })
        })
      }
    }
    setOptions(items)
  }, [id, roleManagementOptions])

  const navigate = (direction) => {
    let userList = []
    if (userInput && userInput.users) {
      userList = userInput.users
    } else if (userswithRole) {
      userList = userswithRole
    }
    const nextUserIndex = direction === 'next' ? userIndex + 1 : userIndex - 1

    setUserIndex(nextUserIndex)
    if (nextUserIndex < userList.length && nextUserIndex >= 0) {
      const navigatedUser = userList[nextUserIndex]
      setId(navigatedUser.id || navigatedUser.resourceKey || navigatedUser.info.resourceKey) //resourceKey is for member directory
    }
  }

  const sendMessage = (anotherUserId) => {
    if (isMessenger) {
      closeModal()
      if (isNative) {
        window.location = config.webUrl + `/0/messenger/native/messenger?userid=${anotherUserId}`
      } else {
        window.location = config.webUrl + `/0/messenger?userid=${anotherUserId}`
      }
    } else if (showSendMessageModal) {
      showSendMessageModal(anotherUserId)
    }
  }

  useEffect(() => {
    if (userInput && userInput.decryptedProfilePicture) {
      setProfilePicture(userInput.decryptedProfilePicture)
    } else if (user && user.profile_picture_data) {
      const { profile_picture, is_original, original_tag, mime_type } = user.profile_picture_data
      getDescryptedMedia(profile_picture, is_original, original_tag, mime_type, user.id, true).then((data) => {
        setProfilePicture(data.img)
      })
    }
  }, [user])

  const closeModal = () => {
    if (closeModalWithRole) {
      closeModalWithRole()
    } else {
      dispatch(lightProfileActions.closeLightProfileModal())
    }
  }

  const showContent = () => {
    return loading ? (
      <Loader className={styles.loader} />
    ) : screenType === 'messenger' ? (
      <MessengerMobile
        isMobile={true}
        isNative={isNative}
        fromProfile={isProfile ? true : false}
        fromLightProfile={isMessenger ? false : true}
        userId={id}
        messageToSend={messengerMessage}
        closeMessengerPopup={hideSendMessageModal}
        closeLightProfile={closeModal}
        setIsFileModalOpen={setIsFileModalOpen}
        containerCSS={styles.containerCSS}
      />
    ) : (
      <LightProfile
        user={user}
        userStatus={userStatus}
        profilePicture={profilePicture}
        interests={interests}
        prompts={user.prompts}
        interestGroups={interestGroups}
        expertiseGroups={expertiseGroups}
        mixrs={mixrs}
        expertises={user?.expertises?.expertises || []}
        isMobile={isMobile || isNative}
        isNative={isNative}
        screenType={screenType}
        changeScreen={changeScreen}
        organizationId={getOrganizationId()}
        sendMessage={sendMessage}
        showSendMessage={loggedInUser.id !== id && !invalidUser}
        navigate={navigateWithRole ? navigateWithRole : navigate}
        usersCount={userInput && userInput.users ? userInput.users.length : userswithRole ? userswithRole.length : 0}
        userIndex={userIndex}
        isLoggedUser={loggedInUser.id === id}
        error={error}
      />
    )
  }

  return (
    <React.Fragment>
      {isMobile ? (
        <MobileModal
          isOpen={show}
          lockScroll
          className='lightprofile_mobile'
          customContentStyle={{ height: '98%', padding: '0', border: '0' }}
          handleClose={closeModal}
          headerCSS={styles.headerNavigation}
          draggableDivCSS={styles.draggableDiv}
          backCSS={styles.back}
          optionsCSS={styles.options}
          closeOnDocumentClick={isFileModalOpen ? false : true}
          showDefaultHeader={screenType === 'main'}
          showOptions={options.length > 0 && !invalidUser}
          optionsChildren={<ReactMenu options={options} menuButtonCSS={styles.optionButton} />}>
          {showContent()}
        </MobileModal>
      ) : (
        <Modal
          className='lightprofile_desktop'
          isOpen={show}
          lockScroll
          closeOnDocumentClick={false}
          customContentStyle={{
            width: '25rem',
            height: '45rem',
            borderRadius: '22px',
            boxShadow: '0 -8px 16px 0 rgba(96, 97, 112, 0.16), 0 2px 4px 0 rgba(40, 41, 61, 0.04)',
            padding: '0'
          }}
          handleClose={closeModal}
          showDefaultHeader={screenType === 'main'}
          showOptions={options.length > 0 && !invalidUser}
          headerCSS={styles.headerNavigation}
          closeCSS={styles.back}
          optionsCSS={styles.options}
          optionsChildren={<ReactMenu options={options} menuButtonCSS={styles.optionButton} />}>
          {showContent()}
        </Modal>
      )}
    </React.Fragment>
  )
}
